<template>
<Layout>
<PageHeader :title="title" :items="items" />

    <v-app>
        <!-- <v-card> -->
        <v-row>
            <v-col>

                <v-row>
                    <v-col>
                        <v-row>
                            <v-col cols="12">
                                <span>
                                    <v-checkbox 
                                        v-model="buscar" 
                                        :label="`Buscar Produtos?`" class="ml-3">
                                    </v-checkbox>
                                </span>
                            </v-col>
                        </v-row>
                        <v-card v-if="buscar">
                            <v-card-title>Localizar produtos</v-card-title>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field class="ml-2 mr-2" v-model="searchProdutos" append-icon="mdi-binoculars" label="Buscar" @keypress.enter="buscarProdutosPorNome"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field class="ml-2 mr-2" v-model="search" append-icon="mdi-filter" label="Filtrar"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>

                <v-data-table
                    dense
                    :headers="headers"
                    :items="itens"
                    :search="search"
                    class="elevation-1"
                    :loading="loading"
                    loading-text="Carregando..."
                >

                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-toolbar-title>Produtos</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                            <v-btn class="mb-2" color="warning" dark @click="buscarProdutosPorNome"><v-icon>cached</v-icon></v-btn>
                            
                            <v-dialog class="mtDialog"
                                v-model="dialog" max-width="50vw" max-height="100"
                                persistent
                                scrollable>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                                        <v-icon>add_box</v-icon>
                                    </v-btn>
                                </template>
                                <v-card height="74vh">
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="2">
                                                    <v-text-field v-model="editedItem.id" label="ID" disabled></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="5">
                                                    <v-text-field v-model="editedItem.codigo" label="Código"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="5">
                                                    <v-text-field v-model="editedItem.descricao" label="Descrição"></v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-select v-model="editedItem.subcategoria" :items="subcategorias" label="Sub Categorias"></v-select>
                                                    <!-- v-autocomplete não funcionava no celular -->
                                                    <!-- <v-autocomplete
                                                        v-model="editedItem.subcategoria"
                                                        :items="subcategorias"
                                                        label="Sub Categorias"
                                                        item-text="descricao"
                                                        item-value="id"
                                                        return-object
                                                    >

                                                    </v-autocomplete> -->
                                                </v-col>
                                                <v-col cols="12" sm="3">
                                                    <!-- <v-text-field v-model="editedItem.stock" label="Estoque" disabled></v-text-field> -->
                                                    <v-text-field v-model="editedItem.estoque" label="Estoque" disabled></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3">
                                                    <v-text-field v-model="editedItem.preco" label="Preço" type="number"></v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col>
                                                    <template>
                                                        <v-file-input
                                                            @change="changeImage"
                                                            v-model="fileSelected"
                                                            label="Foto do produto"
                                                            filled
                                                            prepend-icon="mdi-camera"
                                                        ></v-file-input>
                                                    </template>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col>
                                                    <v-img
                                                        :width="width"
                                                        max-width="600"
                                                        :src="showImageList(editedItem.imagem)"
                                                        id="foto"
                                                        ></v-img>
                                                    <v-slider
                                                        v-model="width"
                                                        class="align-self-stretch"
                                                        min="200"
                                                        max="600"
                                                        step="1"
                                                        ></v-slider>
                                                </v-col>
                                            </v-row>
                                            
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                                        <v-btn color="pink accent-3" text @click="save">Salvar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                        </v-toolbar>                        
                    </template>
                    
                    <template v-slot:item.acoes="{ item }">
                        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                        <v-icon small color="danger" @click="deleteItem(item)">mdi-delete</v-icon>
                        <v-icon small color="danger" @click="mostraEstoqueLojas(item)">mdi-eye</v-icon>
                    </template>

                    <template v-slot:item.imagem="{ item }">
                        <!-- <img :src="row.item.imagem" style="height:50px" alt="" srcset=""> -->
                        <img :src="showImageList(item.imagem)" alt="" srcset="" class="tamanhoImagem">
                        <!-- <img :src="`${img_url}${row.item.imagem}`" style="height:50px" alt="" srcset=""> -->
                    </template>

                    <template v-slot:no-data>
                        <v-btn color="primary" @click="iniciar">Reiniciar</v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        


        <!-- MODAL MOSTRA ESTOQUE DE TODAS AS EMPRESAS -->
        <v-row justify="space-around">
            <v-col cols="auto">
                <v-dialog class="mtDialog"
                    transition="dialog-top-transition"
                    max-width="600px"
                    v-model="dialogEstoques"  
                    persistent
                    scrollable>
                    <template v-slot:activator="{ on, attrs }">
                        
                    </template>
                    <v-card>
                        <v-card-title>
                            <!-- <span class="headline">Estoque Geral</span> -->
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row v-if="itensEstoque.length">
                                    <!-- inicio tabela -->
                                    <v-data-table
                                        dense
                                        :headers="headersEstoques"
                                        :items="itensEstoque"
                                        class="elevation-1"
                                        :loading="loading"
                                        loading-text="Carregando..."
                                    >
                                        <template v-slot:top>
                                            <v-toolbar flat color="white">
                                                <v-toolbar-title>Estoques</v-toolbar-title>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                <v-spacer></v-spacer>
                                                <v-btn class="mb-2" color="warning" dark ><v-icon>cached</v-icon></v-btn>
                                                
                                        </v-toolbar>                        
                                        </template>

                                        <template v-slot:no-data>
                                            <v-btn color="primary" >Reiniciar</v-btn>
                                        </template>

                                    </v-data-table>                            
                                </v-row>
                                <v-row v-else>
                                    <v-col cols="12">
                                        <h1 class="text-center">Produto sem estoque</h1>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeModalEstoques">Fechar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>

        <!-- </v-card> -->
    </v-app>
    </Layout>
</template>


<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";

import {ApiInv} from './ApiInv'

export default {
    name:"Produto",
    components:{
        Layout, PageHeader
    },
    props:[],/*
    directives:{
        money: function(el, binding){
        
            //const amount = parseFloat(el.innerHTML).toFixed(2).replace('.',',').replace(/(\d)(?=(\d{3})+\,)/g, '$1.')
            const amount = parseFloat(el.innerHTML).toFixed(2).replace('.',',').replace(/(\d)(?=(\d{3})+,)/g, '$1.')
            el.innerHTML = `${binding.value} ${amount}`
        
        //usar v-money="'R$'"
        }
    },*/
    data() {
        return {
            title: "Lista de produtos",
            items: [
                {
                text: "Dashboard",
                href: "/home",
                },
                {
                text: "Produtos",
                active: true,
                },
            ],
            width:300,
            fileSelected:null,
            thumbnail:null,
            itens:[],
            api: new ApiInv,
            img_url:null,
            loading:false,
            search: "",
            searchProdutos:"",
            buscar:false,
            headers:[
                {text: "ID", value: "id"},
                {text: "Código", align: 'start', sortable: true, value: 'codigo'},
                {text: "Descrição", align: 'start', sortable: true, value: 'descricao'},
                //{text: "Estoque", sortable: false, value: 'stock'},
                {text: "Estoque", sortable: false, value: 'estoque'},
                {text: "Preço", sortable: false, value: 'preco', align: 'end'},
                {text: "Sub Categoria", sortable: false, value: 'subcat_descricao'},
                {text: "Ações", value:'acoes', sortable:false},
                {text: "Imagem", value:'imagem', sortable:false},
                
            ],
            headersEstoques:[
                {text: "Empresa", align: 'start', sortable: true, value: 'empresa_nome'},
                {text: "Quantidade", align: 'start', sortable: true, value: 'quantidade'},
                
            ],
            dialog:false,
            editedIndex:-1,
            editedItem:{ id:-1, codigo:"", descricao:"", stock:0, preco:0, subcategoria:{"id":-1, descricao:""}, imagem:null, thumbnail:null},
            defaultItem:{ id:-1, codigo:"", descricao:"", stock:0, preco:0, subcategoria:{"id":-1, descricao:""}, imagem:null, thumbnail:null},
            subcategorias:[],
            empresa:{},
            dialogEstoques:false,
            itensEstoque:[],
        }
    },
    created() {
        //this.iniciar()
        this.img_url = this.api.IMG_URL
        this.iniciarSubcategorias()
    },
    mounted() {
        if((localStorage.getItem("empresa") !== 'undefined') && (localStorage.getItem("empresa") !== null)){
            this.empresa = JSON.parse(localStorage.getItem("empresa"))
        } else {
            this.mensagem("Selecione uma empresa!", "Atenção", "warning") //mixin
            this.empresa = {}
            this.$router.push('/empresas')
        }
    },
    methods: {
        changeImage(){
            this.editedItem.imagem = URL.createObjectURL(this.fileSelected)
        },
        showImageList(imagem){
            let result = ''
            if(imagem){
                if(imagem.startsWith('/media')){
                    result = this.img_url + imagem
                } else {
                    result = imagem
                }
            } else {
                result = this.img_url + 'media/img/empty.png'
            }
            return result
        },
        showUrlImagem(obj){
            if(obj){
                console.log(obj)
                return obj
            } 
            return this.img_url + 'media/img/empty.png'
        },
       async iniciar(){
           this.img_url = this.api.IMG_URL
           try {
                this.loading = true
                let produtos = await this.api.getProdutos()
                if(produtos.detail){
                    this.$swal({title: 'Atenção!', text:produtos.detail, icon: 'warning'})  
                    this.$router.push('login')
                }
                this.itens = produtos

                /* this.itens.forEach(item => {
                    item.preco = `R$ ${(item.preco.toFixed(2).replace('.',','))}`
                }); */
                
                let aux
                this.itens.forEach(item => {
                    item.estoque = 0
                    aux = item.estoque_empresa[this.empresa.id-1]
                    console.log(item.descricao, aux, typeof(aux))
                    item.estoque_empresa.forEach(it =>{
                        
                        console.log('quantidade', it.quantidade)
                        console.log('item empresa' ,it.empresa, this.empresa.id)
                        if(it.empresa === this.empresa.id){
                            item.estoque = it.quantidade
                        }
                        console.log('item.estoque: ', item.estoque)
                    })
                });                 

                //this.subcategorias = await this.api.getSubCategorias()
                //para usar categorias com o v-select
                let subcat = await this.api.getSubCategorias()
                subcat.forEach(element => {
                    this.subcategorias.push({text:element.descricao, value: element.id})
                });
           } catch (error) {
                this.$swal("Error", error.toString())
           } finally{
               this.loading = false
           }
       },
       async iniciarSubcategorias(){
           let subcat = await this.api.getSubCategorias()
           subcat.forEach(element => {
                this.subcategorias.push({text:element.descricao, value: element.id})
           });
       },
       close(){
           this.fileSelected = null
           this.dialog = false
           this.$nextTick(()=>{
               this.editedItem = Object.assign({}, this.defaultItem)
               this.editedIndex = -1
           })
       },
       editItem(item){
           this.editedIndex = this.itens.indexOf(item)
           this.editedItem = Object.assign({}, item)
           this.dialog = true
           console.clear()
           console.log(this.editedItem)
       },
       async deleteItem(item){
           /* await this.api.delProduto(item.id)
           this.iniciar() */

           this.$swal.fire({
            title: 'Tem certeza?',
            html: `Apagar o produto <br><b>${item.descricao}</b>`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim!',
            cancelButtonText: 'Não!',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33'
            }).then( async (result) => {
                if (result.isConfirmed) {
                    const resposta = await this.api.delProduto(item.id)
                    if(resposta.ok){
                       this.$toastr.s(`Eliminado ${item.descricao}`);
                       await this.iniciar();
                   } else {
                       this.$toastr.e(`Erro: ${resposta.statusText}`);
                   }
                } else {
                    this.$swal.fire('Cancelado!','O produto foi mantido.','info')
                }
            })
       },
       async save(){
           //const obj = this.editedItem

           const cp = this.editedItem
           const cat = cp["subcategoria"]
           let idCat = null

           if(cat["id"]!==undefined){
               idCat = cat["id"]
           } else {
               idCat = cat
           }
        
           const objProduto = {
               id:cp["id"],
               codigo: cp["codigo"],
               descricao: cp["descricao"],
               stock: cp["stock"],
               preco: cp["preco"],
               subcategoria: idCat,
               subcategoria_id: idCat,
               imagem:this.fileSelected,
               thumbnail:this.fileSelected,
               estoque_empresa:JSON.stringify({produto:-1,empresa:4,quantidade:36})
               
           }

           //
           const obj = new FormData()
            for (const key in objProduto) {
                    if(key == 'imagem'){
                        if(objProduto[key]!==null){
                            obj.append('imagem', objProduto[key])
                            obj.append('thumbnail', objProduto[key])
                        }
                    } else {
                        if(key != 'thumbnail')
                            obj.append(key, objProduto[key])
                    }
                }

           //

           try {
               this.loading = true
               const res = await this.api.saveProduto(obj)
               //if(typeof(res)=='string' || typeof(res)=='undefined'){
               if(typeof(res)=='string'){
                    this.$swal({title: 'Erro!', text:res, icon: 'error'})    
                    return false
               }
               console.log('res do produto: ', res)
               this.close()
               //this.iniciar()
               this.buscarProdutosPorNome()
               this.$swal({text:'Salvo com sucesso!', icon: 'success'})
           } catch (error) {
               this.$swal({title: 'Erro!', text:error.toString(), icon: 'error'})
           } finally{
               this.loading = false
           }
       },
        async buscarProdutosPorNome() {
            try {
                this.loading = true;
                this.buscadoProduto = [];

                    if (this.searchProdutos != "") {
                    const produtos = await this.api.getProdutoByName(
                        this.searchProdutos
                    )
                    if (produtos.detail != undefined) {
                        //this.$$refs.idproduto.select()
                        this.$swal("Erro:", produtos.detail);
                    } else {
                        this.itens = produtos
                        //this.buscadoProduto = produtos;
                        
                        /* ESTOQUE */
                        //let aux
                        //let loja
                        //loja = parseInt(this.empresa.id)-1
                        this.itens.forEach(item => {
                            item.estoque = 0
                            //aux = item.estoque_empresa[loja]
                            //console.log(item.descricao, aux, typeof(aux))
                            //console.log(item.estoque_empresa)
                            
                            item.estoque_empresa.forEach(it =>{
                                
                                //console.log('quantidade', it.quantidade)
                                //console.log('item empresa' ,it.empresa, this.empresa.id)
                                if(it.empresa === this.empresa.id){
                                    item.estoque = it.quantidade
                                }
                                //console.log('item.estoque: ', item.estoque)
                            })
                        });             
                    }
                } else {
                    this.$swal("Atenção", 'Informe o produto a procurar');
                    return
                }
            } catch (error) {
                this.$swal("Erro", error.toString());
            } finally {
                this.loading = false;
            }
        },   
        mostraEstoqueLojas(itemAtual){
            let texto = []
            
            console.clear()
            console.log(itemAtual)
            itemAtual.estoque_empresa.forEach(item =>{
                console.log(item.empresa_nome, 'Qtd: ',item.quantidade)
                //let msg = {}
                //msg.loja = item.empresa_nome
                //msg.qtd = item.quantidade
                //texto.push(msg)
                texto.push(item.empresa_nome)
            })
            texto = JSON.stringify(texto)
            console.log(texto)
            console.log(typeof(texto))
            //this.$swal("Atenção", texto);
            this.itensEstoque = itemAtual.estoque_empresa
            this.dialogEstoques = true
        },   
        closeModalEstoques(){
            this.dialogEstoques = false
        } 
    },
    computed:{
        formTitle(){
            return (this.editedIndex === -1 ? "Novo " : "Editar ") + 'Produto'
        }
    },
    watch:{
        dialog(val){
            val || this.close()
        }
    }
}
</script>


<style scope>

@media (max-width:767px){
    .tamanhoImagem{
        max-width:200px;
    }
    .mtDialog{
        margin-top: 100px;
        position: absolute !important;
        bottom: 0 !important;
        color: red;
    }

}

@media (min-width:768px){
    .tamanhoImagem{
        max-width:50px;
    }

}



</style>

